import { render, staticRenderFns } from "./HistoryCoupon.vue?vue&type=template&id=95df7974&scoped=true&"
import script from "./HistoryCoupon.vue?vue&type=script&lang=js&"
export * from "./HistoryCoupon.vue?vue&type=script&lang=js&"
import style0 from "./HistoryCoupon.vue?vue&type=style&index=0&id=95df7974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95df7974",
  null
  
)

export default component.exports